import { render, staticRenderFns } from "./history5.vue?vue&type=template&id=54519852&scoped=true&"
import script from "./history5.vue?vue&type=script&lang=js&"
export * from "./history5.vue?vue&type=script&lang=js&"
import style0 from "./history5.vue?vue&type=style&index=0&id=54519852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54519852",
  null
  
)

export default component.exports